import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import './styles.scss';
import clsx from 'clsx';

const DropdownData = ({
  label,
  defaultValue,
  dataOptions,
  onChange,
  placeholder,
  flat,
  value,
  optional,
  ...props
}) => {
    
  const options = dataOptions.map(item => ({
    label: item.value,
    value: item.value,
    raw: item
  }));

  const selectedValue = options.find(opt => opt.value === value);

  const handleChange = selectedOption => {
    if (onChange) {
      onChange({
        value: selectedOption.value,
        label: selectedOption.label,
        raw: selectedOption.raw, // pass full object
        kind: props.kind
      });
    }
  };

  const customDropdownStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: '#0c2e78',
      color: 'white',
      border: 'none',
      boxShadow: 'none',
      borderRadius: '2px',
      minHeight: '48px',
      paddingLeft: '13px',
      fontSize: '1.125rem',
      transition: 'none',
    }),
    singleValue: (base) => ({
      ...base,
      color: 'white',
      fontSize: '1.125rem',
    }),
    placeholder: (base) => ({
      ...base,
      color: 'rgba(255, 255, 255, 0.7)',
      fontSize: '1.125rem',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: 'white',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    valueContainer: (base) => ({
      ...base,
      padding: 0,
      margin: 0,
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: '#0c2e78',
      zIndex: 9999,
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: 250,
      overflowY: 'auto',
    }),
    option: (base, state) => ({
      ...base,
      fontSize: '1.125rem',
      color: 'white',
      backgroundColor: state.isSelected
        ? '#062060'
        : state.isFocused
        ? '#1a3e99'
        : '#0c2e78',
      cursor: 'pointer',
      ':active': {
        backgroundColor: '#062060',
      },
    }),
    input: (base) => ({
      ...base,
      color: 'white',
    }),
  };


  return (
    <div className='dropdown-field'>
      {label && <label className='dropdown-label'>{label}</label>}

      <Select
        options={options}
        value={selectedValue}
        onChange={handleChange}
        placeholder={placeholder}
        className={clsx('dropdown-x', optional && '-optional')}
        classNamePrefix="react-select"
        {...props}
        styles={customDropdownStyles}
      />
    </div>
  );
};

DropdownData.propTypes = {
  label: PropTypes.string,
  defaultValue: PropTypes.array,
  dataOptions: PropTypes.object,
  placeholder: PropTypes.string,
  onChange: PropTypes.func
};

DropdownData.defaultProps = {
  label: '',
  dataOptions: [],
  placeholder: 'Select an option.',
  onChange: () => {}
};

export default DropdownData;
